module.exports = __webpack_public_path__ + "static/media/logo.82b50001.svg";